// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"aba57946","977":"12f146f4"}[chunkId] + ".chunk.js";
};